module.exports = __webpack_public_path__ + "static/media/Multi_Asset_Allocation.5b784ee4.svg";